export default {
  // enterpriseProLaborForm: createReducer(initialState, {
  //   [types.GET_ENTERPRISE_PRO_LABOR_MODAL_FORM_SUBMIT](state, action) {
  //     return {
  //       ...state,
  //       submit: action.payload,
  //     }
  // },
  // }),
  //   INSERTION_PT (for script, do not remove)
};
